<template>
  <premium-detail is-create />
</template>

<script>
export default {
  name: 'CreatePremium',
  components: {
    PremiumDetail: () => import('./detail')
  }
}
</script>
